import { OrgInfoFormValues } from 'types/orgInfoTypes';

export const createOrgInfoFormValues = (): OrgInfoFormValues => ({
  name: '',
  location: null,
  staffCount: null,
});
